/**
 * Centralized file utility functions
 * Shared across components to ensure consistency
 */

/**
 * Format file size for display
 * @param {number} bytes - Size in bytes
 * @returns {string} - Formatted size (e.g., "1.5 MB")
 */
export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);

    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Handle download for blob URLs
 * Works around browser limitations with blob URL downloads
 * @param {string} url - Blob URL or regular URL
 * @param {string} filename - Name for the downloaded file
 */
export function handleFileDownload(url, filename) {
    if (url.startsWith('blob:')) {
        // For blob URLs, fetch and convert to data URL for reliable download
        fetch(url)
            .then(res => res.blob())
            .then(blob => {
                const reader = new FileReader();
                reader.onload = () => {
                    const link = document.createElement('a');
                    link.href = reader.result;
                    link.download = filename;
                    link.click();
                };
                reader.readAsDataURL(blob);
            })
            .catch(err => {
                console.error('Download failed:', err);
                // Fallback to direct link
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                link.click();
            });
    } else {
        // Regular URLs work fine with default download behavior
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
    }
}
